import { SORT_ORDERS } from "@/core/constants/sortOrders";

export class QueryUrlBuilderService {
  baseUrl = "";
  parameters = [];
  finalUrl = "";

  /**
   * @param baseUrl
   */
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  /**
   * Add pagination to the url
   * @param {?int} page
   * @param {?int} perPage
   * @param {boolean} pagination
   * @return {QueryUrlBuilderService}
   */
  withPagination(page = null, perPage = null, pagination = true) {
    if (!pagination) {
      return this.withoutPagination();
    }
    this.parameters.push("pagination=true");
    if (page) {
      this.parameters.push(`page=${page}`);
    }
    if (perPage) {
      this.parameters.push(`itemsPerPage=${perPage}`);
    }

    return this;
  }

  withoutPagination() {
    this.parameters.push("pagination=false");

    return this;
  }

  /**
   * Add custom filters
   * @param {object|Map} filters - each value can be a string or an array
   * @return {QueryUrlBuilderService}
   */
  withFilters(filters) {
    // Objectify filters
    filters = filters instanceof Map ? Object.fromEntries(filters) : filters;

    Object.entries(filters).map(([filter, value]) => {
      if (value instanceof Array) {
        this.addArrayFilter(filter, value);
        return;
      }

      this.addFilter(filter, value);
    });

    return this;
  }

  withSort(property, order = SORT_ORDERS.ASC) {
    if (property && order) {
      this.parameters.push(`order[${property}]=${order}`);
    }
    return this;
  }

  withoutCount() {
    this.parameters.push("partial=true");
  }

  /**
   * @param {string} filter
   * @param {string|number|boolean} value
   * For 'value' we accept false and 0, but not null, undefined or empty string
   */
  addFilter(filter, value) {
    if (filter && (value || value === false || value === 0)) {
      this.parameters.push(`${this._encode(filter)}=${this._encode(value)}`);
    }
  }

  /**
   * @param {string} filter
   * @param {string[]} values
   */
  addArrayFilter(filter, values) {
    if (filter && values?.length > 0) {
      filter = this._encode(filter);

      this.parameters.push(values.map((value) => `${filter}[]=${this._encode(value)}`).join("&"));
    }
  }

  /**
   * @param {string} value
   * @return {string}
   * @private
   */
  _encode(value) {
    return encodeURIComponent(value);
  }

  /**
   * Build and return the final url
   * @return {string}
   */
  get() {
    let finalUrl = this.baseUrl;

    if (Object.keys(this.parameters).length > 0) {
      const strParams = this.parameters.join("&");

      finalUrl += `?${strParams}`;
    }

    return finalUrl;
  }
}
